var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeftIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.17758 14.115C7.03508 14.115 6.89258 14.0625 6.78008 13.95L2.22758 9.3975C2.01008 9.18 2.01008 8.82 2.22758 8.6025L6.78008 4.05C6.99758 3.8325 7.35758 3.8325 7.57508 4.05C7.79258 4.2675 7.79258 4.6275 7.57508 4.845L3.42008 9L7.57508 13.155C7.79258 13.3725 7.79258 13.7325 7.57508 13.95C7.47008 14.0625 7.32008 14.115 7.17758 14.115Z",
    fill: "#101323"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3745 9.5625H2.75195C2.44445 9.5625 2.18945 9.3075 2.18945 9C2.18945 8.6925 2.44445 8.4375 2.75195 8.4375H15.3745C15.682 8.4375 15.937 8.6925 15.937 9C15.937 9.3075 15.682 9.5625 15.3745 9.5625Z",
    fill: "#101323"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftIcon);
export default __webpack_public_path__ + "static/media/arrowLeftIcon.cdcf2b14d75c00866557193fcb5e753e.svg";
export { ForwardRef as ReactComponent };